export type AuthenticationState = {
    forgotPassword: {
        loading: boolean;
        success: boolean;
        errorMessage: string;
    };
    setPassword: {
        requested: boolean;
        pending: boolean;
        success: boolean;
    };
    verifyResetCode: {
        code: string;
        pending: boolean;
        success: boolean;
    };
};

export const initialAuthenticationState: AuthenticationState = {
    setPassword: {
        requested: false,
        pending: false,
        success: false,
    },
    forgotPassword: {
        loading: false,
        errorMessage: '',
        success: false,
    },
    verifyResetCode: {
        code: '',
        pending: false,
        success: false,
    },
};
